module.exports = {
  'achievements.pastReservations': ['GET', '/v1/achievements/past_reservations'],
  'achievements.pastReservationsMeta': ['GET', '/v1/achievements/past_reservations_meta'],
  'activities.getList': ['GET', '/v1/activities'],
  'achievements.ackCelebrations': ['POST', '/v1/achievements/celebrations'],
  'achievements.getAchievementsBySection': ['GET', '/v1/achievements/achievements_by_section'],
  'bff.getSettings': ['GET', '/bff/v1/settings'],
  'campaigns.getMobileRaf': ['GET', '/campaigns/v3/mobile/raf/sender/$0'],
  'class.getAttributes': ['GET', '/v1/classes/$0/attributes'],
  'class.getReviews': ['GET', '/v1/classes/$0/reviews'],
  'class.getSchedules': ['GET', '/v1/classes/$0/schedules'],
  'classBundles.getByMsa': ['GET', '/v1/msas/$0/class_bundles'],
  'classBundles.purchaseBundle': ['POST', '/v1/users/$0/class_bundles'],
  'credits.getBounds': ['GET', '/price/v1/credits/bounds'],
  'cms.getAndroidContent': ['GET', '/contentmanagement/v1/space/android/content'],
  'cms.getContent': ['GET', '/contentmanagement/v1/content/'],
  'cms.getContentBySpace': ['GET', '/contentmanagement/v1/space/$0/content'],
  'cms.getMobileContent': ['GET', '/contentmanagement/v1/space/mobile/content'],
  'countries.get': ['GET', '/v1/countries'],
  'countries.getStates': ['GET', '/v1/countries/$0/states'],
  'dash.getFeatureFlag': ['GET', '/v1/features/$0/state'],
  'dynamicTemplates.retrieve': ['POST', '/v1/templates/retrieve'],
  'email.optIn': ['POST', '/v1/email/opt-in/$0'],
  'features.get': ['GET', '/feature/$0'],
  'filters.getByHash': ['GET', '/v1/filters/$0'],
  'filters.getByQuery': ['GET', '/v1/filters'],
  'filters.getRelatedByHash': ['GET', '/v1/filters/$0/related'],
  'fitness.trackDevice': ['POST', '/v1/fitness_devices'],
  'friendbuy.getReferral': ['GET', '/v1/friendbuy/referral/$0'],
  'geolocation.msa': ['GET', '/v1/geo/msa'],
  'geolocation.msaV2': ['GET', '/v2/geo/msa'],
  'gifts.create': ['POST', '/v1/gifts'],
  'gifts.getUserGifts': ['GET', '/v1/users/$0/gifts'],
  'gls.getLocaleInfo': ['GET', '/v1/gls/country/$0/locale'],
  'gls.getUserLocation': ['GET', '/v1/gls/user/location'],
  'gls.getUserLocationV2': ['GET', '/v2/gls/user/location'],
  'gls.getUserLocationInfo': ['GET', '/v1/gls/user/$0/location'],
  'inviteFriends.get': ['GET', '/v1/me/social/schedules/$0'],
  'inviteFriends.sendInvites': ['POST', '/v1/users/$0/social/schedule_invite'],
  'leaderboard.getState': ['GET', '/v1/leaderboard/classes/$0/state'],
  'leaderboard.joinClass': ['POST', '/v1/leaderboard/classes/$0/join'],
  'leaderboard.leaveClass': ['POST', '/v1/leaderboard/classes/$0/leave'],
  'leaderboard.updateHeartrate': ['PATCH', '/v1/leaderboard/classes/$0/state'],
  'leaderboard.sendHeartrate': ['POST', '/v1/leaderboard/heart_rate'],
  'leaderboard.updateStatus': ['POST', '/v1/leaderboard/classes/$0/client_event'],
  'lifecycle.getCreditBalance': ['GET', '/v1/lifecycle/user/$0/balance'],
  'lifecycle.getCreditBalanceBreakdown': ['GET', '/v1/lifecycle/user/$0/balance/breakdown'],
  'locations.getListV2': ['GET', '/v2/locations'],
  'locations.getByPostalCode': ['GET', '/v1/postal_code/$0'],
  'modal.get': ['GET', '/v1/me/modal'],
  'msas.getList': ['GET', '/v1/msas'],
  'msas.getById': ['GET', '/v1/msas/$0?include_all=1'],
  'msas.getCreditStats': ['GET', '/credit_price/v1/credits/data/msa/$0/stat'],
  'msas.getHoldPlan': ['GET', '/v1/msas/$0/hold_plan'],
  'pages.getPageByKey': ['GET', '/pages/v1/pages/$0'],
  'plans.getByIdV2': ['GET', '/v2/plans/$0'],
  'plans.getByMsaV3': ['GET', '/v3/msas/$0/plans'],
  'plans.getUserSaveOffer': ['GET', '/v1/users/$0/save_offer'],
  'plans.getLiveByMsa': ['GET', '/subscriptions/v1/msas/$0/plans/digital'],
  'plans.getLive': ['GET', '/subscriptions/v1/users/me/plans/digital'],
  'plans.getLiveById': ['GET', '/subscriptions/v1/users/me/plans/digital/$0'],
  'plans.getLiveAssets': ['GET', '/subscriptions/v1/users/me/plans/digital/assets'],
  'plans.getLiveAssetsByMsa': ['GET', '/subscriptions/v1/msas/$0/plans/digital/assets'],
  'phoneVerification.checkValidationCode': ['POST', '/v1/phone_verification/complete'],
  'phoneVerification.sendValidationCode': ['POST', '/v1/phone_verification/start'],
  'phoneVerification.isUserVerified': ['GET', '/v1/phone_verification'],
  'phoneVerification.getValidationCodeStatus': ['GET', '/v1/phone_verification/status/$0'],
  'promos.getMsaPromotionById': ['GET', '/v1/promotions/$0'],
  'promotions.getDefaultPromotionForState': ['GET', '/promotion/v1/promotions/state/$0'],
  'promotions.getMsaOfferById': ['GET', '/promotion/v1/msa_offers/$0'],
  'promotions.getPromotionByAlias': ['GET', '/promotion/v1/promotions/$0'],
  'promotions.getPromotionByAliasV2': ['GET', '/promotion/v2/promotions/$0'],
  'promotions.getV3': ['GET', '/v3/promotions/$0'],
  'promotions.list': ['GET', '/v2/promotions'],
  'reservations.create': ['POST', '/v1/users/$0/reservations'],
  'reservations.update': ['PATCH', '/v1/users/$0/reservations/$1'],
  'reservations.createVideoReservation': ['POST', '/v1/users/$0/videos/reservations'],
  'salesTax.estimate': ['POST', '/v1/sales-tax/estimate'],
  'schedules.getScheduleById': ['GET', '/v1/schedules/$0'],
  'search.autocomplete': ['POST', '/v1/search/autocomplete'],
  'search.getLayout': ['POST', '/unisearch/v1/layout/$0'],
  'search.getLayoutV3': ['POST', '/unisearch/v3/layout/$0'],
  'search.filters.verticals': ['GET', '/v1/admin/verticals'],
  'search.keyword.autocomplete': ['POST', '/unisearch/v1/keyword/autocomplete'],
  'search.keyword.history': ['GET', '/unisearch/v1/users/$0/keyword/history'],
  'search.keyword.addHistoryItem': ['POST', '/unisearch/v1/users/$0/keyword/history'],
  'search.keyword.clearHistory': ['DELETE', '/unisearch/v1/users/$0/keyword/history'],
  'search.keyword.removeHistoryItem': ['DELETE', '/unisearch/v1/users/$0/keyword/history/$1'],
  'search.keyword.removeHistoryItemV2': ['DELETE', '/unisearch/v1/users/$0/keyword/history/$1/$2'],
  'search.location.autocomplete': ['POST', '/unisearch/v1/location/autocomplete'],
  'search.location.details': ['GET', '/unisearch/v1/location/details/$0'],
  'search.location.detailsLonLat': ['POST', '/unisearch/v1/location/details'],
  'search.location.history': ['GET', '/unisearch/v1/users/$0/locations'],
  'search.location.clearHistory': ['DELETE', '/unisearch/v1/users/$0/locations'],
  'search.location.saveForUser': ['PUT', '/unisearch/v1/users/$0/locations/$1'],
  'search.location.removeHistoryItem': ['DELETE', '/unisearch/v1/users/$0/locations/$1'],
  'search.venues': ['POST', '/unisearch/v1/venues'],
  'search.schedules': ['POST', '/v1/search/schedules'],
  'search.getPreferences': ['GET', '/unisearch/v1/preferences/user/$0'],
  'search.getPreferenceDrivenClassRecommendations': ['POST', '/unisearch/v1/preferences/user/$0'],
  'search.submitPreferences': ['POST', '/unisearch/v1/preferences'],
  'search.getSchedulesByCursor': ['GET', '/v1/search/schedules'],
  'search.schedulesV3': ['POST', '/v3/search/schedules'],
  'search.getSchedulesByCursorV3': ['GET', '/v3/search/schedules'],
  'social.getEnrollment': ['GET', '/v1/users/$0/social/enrollment'],
  'social.getPrivacySettings': ['GET', '/v1/users/$0/social/privacy_settings'],
  'social.setEnrollment': ['POST', '/v1/users/$0/social/enrollment'],
  'social.setPrivacySettings': ['POST', '/v1/users/$0/social/privacy_settings'],
  'statics.fitnessTrendsMember': ['GET', '/v1/statics/year_in_review_$0/$1'],
  'subscription.create': ['POST', '/v1/users/$0/subscription'],
  'subscription.createCache': ['POST', '/v1/users/$0/subscription_parameter_cache'],
  'subscription.update': ['PATCH', '/v1/users/$0/subscription'],
  'subscription.getBillingHistory': ['GET', '/v1/users/$0/billing_history'],
  'subscription.getV2': ['GET', '/v2/users/$0/subscription'],
  'subscription.createLive': ['POST', '/subscriptions/v1/users/me/subscriptions/digital'],
  'subscription.getLive': ['GET', '/subscriptions/v1/users/me/subscriptions/digital/active'],
  'subscription.redeem': ['POST', '/v1/users/$0/redemptions'],
  'subscription.hold': ['POST', '/v1/me/subscription/hold'],
  'tags.get': ['GET', '/tags/v1/tags'],
  'tags.getV3': ['GET', '/tags/v3/tags'],
  'tags.contentTags': ['POST', '/tags/v1/query/content.tags'],
  'tags.contentTagsV2': ['POST', '/tags/v2/query/content.tags'],
  'tags.taggedContent': ['POST', '/tags/v1/query/tagged.content'],
  'taxes.getAmount': ['POST', '/v1/taxes'],
  'transactions.paymentTypes': ['GET', '/v1/transactions/accepted_payment_types/$0'],
  'userActionCampaign.referral': ['GET', '/v1/user-action/claim/$0'],
  'userActionCampaign.event': ['GET', '/v1/me/user-action/event/$0'],
  'users.activeUserProfile': ['GET', '/v1/me/profile'],
  'users.announcements': ['GET', '/v2/campaign/announcements/list'],
  'users.claimAnnouncements': ['POST', '/v2/campaign/announcements/claim/$0'],
  'users.updateUserProfile': ['PATCH', '/v1/me/profile'],
  'users.addBookmark': ['POST', '/v1/users/$0/bookmarks'],
  'users.confirmEmailToken': ['PATCH', '/v1/auth/update_email/$0'],
  'users.create': ['POST', '/v1/users'],
  'users.createWithMsa': ['POST', '/v2/users'],
  'users.deleteBookmark': ['DELETE', '/v1/users/$0/bookmarks/$1'],
  'users.getFriendbuy': ['GET', '/v1/users/$0/friendbuy'],
  'users.getBookmarks': ['GET', '/v1/users/$0/bookmarks'],
  'users.inactivePermissions': ['GET', '/v1/users/$0/permissions?all=1'],
  'users.loginWithCredentials': ['POST', '/v2/auth/login'],
  'users.loginWithFacebook': ['POST', '/v2/auth/facebook/login'],
  'users.loginWithToken': ['POST', '/v1/auth/persistence_token'],
  'users.setFacebookToken': ['POST', '/v1/auth/facebook/connect'],
  'users.logout': ['POST', '/v1/auth/logout'],
  'users.purchaseALaCarte': ['POST', '/v1/me/purchase/alc'],
  'users.changePassword': ['PATCH', '/v1/me/password'],
  'users.requestPasswordReset': ['POST', '/v1/auth/reset_password'],
  'users.updateMembership': ['POST', '/v2/users/$0/membership'],
  'users.verifyPasswordReset': ['PATCH', '/v1/auth/reset_password/$0'],
  'users.viewFutureReservations': ['GET', '/v1/users/$0/reservations'],
  'users.viewFutureReservationsV2': ['GET', '/v2/users/$0/reservations'],
  'users.viewReservationsV2': ['GET', '/v2/users/$0/reservations'],
  'users.viewPermissions': ['GET', '/v1/users/$0/permissions'],
  'users.viewVideoReservations': ['GET', '/v1/users/$0/videos/reservations'],
  'users.accountSummary': ['GET', '/v1/me/summary'],
  'venues.getClassInfoByVenueAlias': ['GET', '/v1/venues/$0/classes/$1'],
  'venues.getClassesByVenue': ['GET', '/v1/venues/$0/classes'],
  'venues.getList': ['GET', '/v1/venues'],
  'venues.getListV2': ['GET', '/v2/venues'],
  'venues.getNearbyPopularVenue': ['GET', '/v2/venues/$0/nearby_popular'],
  'venues.getSchedulesPerVenue': ['GET', '/v1/venues/$0/schedules'],
  'venues.getVenueById': ['GET', '/v1/venues/$0'],
  'venues.getVenueByIdV2': ['GET', '/v2/venues/$0'],
  'venues.getVenueReviews': ['GET', '/v1/venues/$0/reviews'],
  'venues.getVenueSiblings': ['GET', '/v2/venues/$0/siblings'],
  'venues.getVenueSimilarities': ['GET', '/v2/venues/$0/similarities'],
  'venues.getVenueTimezones': ['GET', '/v1/gls/venue/summary/timezones'],
  'videos.createUserVideoBookmark': ['POST', '/v1/users/$0/videos/bookmarks'],
  'videos.createVideoViewRating': ['POST', '/v1/users/$0/videos/ratings'],
  'videos.getCollectionsByName': ['GET', '/v1/videos/collections/$0/$1'],
  'videos.getStacks': ['GET', '/v2/videos/stacks'],
  'videos.getLiveVideos': ['GET', '/v1/videos/live'],
  'videos.getLiveVideosById': ['GET', '/v1/videos/live/$0'],
  'videos.getLiveVideoIdByLookup': ['GET', '/v1/videos/live/lookup'],
  'videos.getUserVideoBookmarks': ['GET', '/v1/users/$0/videos/bookmarks'],
  'videos.getVideoById': ['GET', '/v1/videos/$0'],
  'videos.getVideoIdByLookup': ['GET', '/v1/videos/lookup'],
  'videos.getVideoViewRatings': ['GET', '/v1/users/$0/videos/ratings'],
  'videos.getVideosFilters': ['GET', '/v1/videos/filters'],
  'videos.getVideosList': ['GET', '/v1/videos'],
  'videos.getOnDemandVideos': ['GET', '/v1/videos/on_demand'],
  'videos.getViewedVideos': ['GET', '/v1/users/$0/videos/views'],
  'videos.videoEvents': ['POST', '/v1/users/$0/videos/events'],
  'waitlist.create': ['POST', '/v1/waitlist'],
};
